module.exports = __webpack_public_path__ + "img/mini.6978950e.png";